import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {ApiService} from './api.service';
import {Log} from '../model/Entities/Log';
import {Filter} from '../model/Helpers/Filter';
import {Pagination} from '../model/Helpers/Pagination';
import {SortInfo} from '../model/Helpers/SortInfo';

@Injectable()
export class LogService extends ApiService<Log> {

    protected apiUrl = 'api/logs';

    protected getObjectType(): any {
        return Log;
    }

    getLogsForObject(
        objectType: string,
        objectId: number,
        pagination: Pagination = null,
        sort: SortInfo = null,
        filters: Filter[] = [],
        params: Object = {}
    ): Observable<any> {
        const allFilters = [
            new Filter('object_type', objectType),
            new Filter('object_id', objectId),
            ...filters
        ];

        return this.getPaginatedList(pagination, sort, allFilters, params);
    }
}



// WEBPACK FOOTER //
// /app/src/services/log.service.ts